import React, { Component } from 'react';
import { Upload, message, Icon } from 'antd';
import { url } from '../../../services/service-utils';
// import styles from './index.less';

class ImageUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUploadIcon: true,

      fileList: [],
    };
  }

  componentDidMount() {
    const { usercode } = this.props;
    if (usercode) {
      this.setState({
        fileList: [
          {
            uid: '-1',
            name: 'image.png',
            status: 'done',
            url: usercode,
          },
        ],
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { usercode } = nextProps;
    if (usercode) {
      this.setState({
        fileList: [
          {
            uid: '-1',
            name: 'image.png',
            status: 'done',
            url: usercode,
          },
        ],
      });
    }
  }

  handleChange = info => {
    let { fileList } = info;
    fileList = fileList.slice(-1);
    fileList = fileList.map(file => {
      if (file.response) {
        if (file.response.code !== 0) {
          message.info(file.response.msg);
        }
      }
      return file;
    });
    fileList = fileList.filter(file => {
      if (file.response) {
        if (file.response.code !== 0) {
          message.info(file.response.msg);
        }
        return file.response.code === 0;
      }
      return true;
    });
    this.setState({ fileList });
    const { callback } = this.props;
    callback(
      fileList[0] &&
        fileList[0].response &&
        fileList[0].response.data &&
        fileList[0].response.data.fileUrl
    );
  };

  render() {
    const { showUploadIcon, fileList } = this.state;
    const me = this;
    const { callback } = this.props;
    const uploadProps = {
      name: 'file',
      action: `${url.url}/web/v3/news/file/upload`,
      listType: 'picture-card',
      withCredentials: true,
      fileList,
      beforeUpload(file) {
        return new Promise((resolve, reject) => {
          const type = ['image/jpeg', 'image/png', 'image/jpg'];
          const isJPG = type.indexOf(file.type) !== -1;
          if (!isJPG) {
            message.error('只能上传jpg/png/jpeg格式图片!');
          }
          const isLt4M = file.size / 1024 / 1024 < 2;
          if (!isLt4M) {
            message.error('图片不能大小超过2MB!');
          }
          if (!isJPG || !isLt4M) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return reject(false);
          }
          return resolve(true);
        });
      },
      onRemove() {
        me.setState({
          fileList: [],
        });
        callback('');
      },
    };

    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">上传图片</div>
      </div>
    );

    return (
      <Upload {...uploadProps} onChange={this.handleChange}>
        {/* <div style={{ backgroundImage: `url('${qrcodeUrl}')` }} className={styles.qrcode}>
          <Icon type="plus" className={showUploadIcon ? '' : 'hide'} />
          <span className={styles.uploadText}>{uploadText}</span>
        </div> */}
        {fileList.length >= 1 || !showUploadIcon ? null : uploadButton}
      </Upload>
    );
  }
}

export default ImageUpload;
